module.exports = __webpack_public_path__ + "static/media/kharnak.c38c803d.png";